import API from '../../API/api';

export default () => {
    var searchParams = new URLSearchParams(location.search);
    const data = {};
    if (searchParams.has('ipWhitelist')) {
        data['ipWhitelist'] = searchParams.get('ipWhitelist');
    }
    return API.GET({
        apiPath: '/api/v2/sca/buyerassist/url/',
        data
    });
};
